<label>{{ 'committees.edit.committee-members.find-members-active-in-range' | translate | ucfirst }}</label>
<div class="mct-flex mct-row mct-flex-lt-sm mct-col-lt-sm mct-justify-start mct-items-center mct-gap-28">
  <div>
    <label>{{ 'committees.edit.committee-members.start-date' | translate | ucfirst }}</label>
    <wl-date-selector [(ngModel)]="searchParams.MemberSince"></wl-date-selector>
  </div>
  <div>
    <label>{{ 'committees.edit.committee-members.end-date' | translate | ucfirst }}</label>
    <wl-date-selector [(ngModel)]="searchParams.DateInactive"></wl-date-selector>
  </div>
  <div class="mct-flex mct-row mct-justify-center mct-items-center">
    <p-checkbox binary="true" [(ngModel)]="searchParams.IncludeInactive" inputId="includeInactiveMembers"> </p-checkbox>
    <label for="includeInactiveMembers">
      {{ 'committees.edit.committee-members.include-inactive-members' | translate | ucfirst }}
    </label>
  </div>
</div>
